module.exports = require('./helpers/bundle-url').getBundleURL('9ZeSD') + "logo.c51670a8.svg";